

  
const content = `# Masking Limitations
When a user does not have read access to certain columns, the values in those columns can be optionally masked, so that the user knows that the actual values are masked. The masking 
rules can be configured from the OnData Portal.

Similar to encryption, the data masking feature is intended to protect sensitive, confidential and regulated data. Please perform data classification on columns before 
applying data masking rules. If a data column is not classified as sensitive, confidential or regulated, no masking rule should be applied to that column.
`
  
export default content;
